import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PurchaseIntentsList } from "@/features/admin/purchase-intents/list";
import {
  filterSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";
import { CheckoutStatus } from "@/types/openapi-enum";

const CHECKOUT_STATUS_VALUES = Object.values(CheckoutStatus) as string[];

const searchSchema = z.object({
  purchaseIntentId: z.string().optional(),
  tab: z.string().optional(),
  filters: z
    .object({
      accountId: withOperators(commaListSchema),
      placeId: withOperators(commaListSchema),
      planKey: withOperators(commaListSchema),
      status: withOperators(
        commaListSchema.superRefine((ids, ctx) => {
          if (!ids?.length) return;
          for (const id of ids) {
            if (!CHECKOUT_STATUS_VALUES.includes(id)) {
              ctx.addIssue({
                code: "custom",
                message: "Invalid checkout status filter",
              });
            }
          }
        }),
      ),
    })
    .optional(),
  ...filterSearchFragment,
  sort: z.string().optional(),
  ...maskSearchFragment,
});

export type PurchaseIntentsListSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/admin/purchase-intents/")({
  validateSearch: searchSchema,
  component: PurchaseIntentsList,
});
